import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})

export class GaleriaService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getClasificaciones() {
    return this.http.get(`${this.API_URI}/galeria`);
  }

  getTodoFotos() {
    return this.http.get(`${this.API_URI}/galeria/todo`);
  }

  getGaleria(id) {
    return this.http.get(`${this.API_URI}/galeria/${id}`);
  }

}
